import { ECS } from '../state';
import AssetService from '@/services/AssetService';
import { getUrlBoolean, getUrlFloat } from '~/helpers/UrlParam';
import { urls } from '@/config/assets';
import { randomIntRange } from '@/helpers/MathUtils';

const debug = getUrlBoolean('debug');

const size = [beerConfig.player.size.x, beerConfig.player.size.y, 0.001];
const frameConfig = {
  run: [0, 10],
  jump: 10,
  crash: 11,
  idle: 12,
};

const speed = getUrlFloat('jeremySpriteSpeed', 0.5);

const isJumping = ECS.world.with('isPlayer', 'isJumping');
const isBlocked = ECS.world.with('isPlayer', 'isBlocked');
const isStopped = ECS.world.with('isPlayer', 'stop');
const PlayerState = {
  getSnapshot: () => {
    const player = players.entities[0];
    if (!player) return 'idle';
    // console.log('PlayerState.getSnapshot', player.isJumping);
    if (player.stop) return 'idle';
    if (player.isBlocked) return 'idle';
    if (player.isJumping) return 'jump';
    return 'run';
  },
  subscribe: (callback) => {
    isJumping.onEntityAdded.subscribe(callback);
    isJumping.onEntityRemoved.subscribe(callback);
    isBlocked.onEntityAdded.subscribe(callback);
    isBlocked.onEntityRemoved.subscribe(callback);
    isStopped.onEntityAdded.subscribe(callback);
    isStopped.onEntityRemoved.subscribe(callback);
  },
};

export const Player = () => {
  const t_jeremy = useAsset(urls.t_jeremy);

  const refEntity = useRef();
  const refSprite = useRef();

  const f = useRef(0);

  const [state, setState] = useState('idle');

  useFrame((_, delta) => {
    const player = players.entities[0];
    // console.log('player.stop', player.stop);

    // JUMPING
    if (player.isJumping) {
      refSprite.current.frame = frameConfig.jump;
      if (state != 'jump') setState('jump');
      return;
    }

    // IDLE
    if (player.stop || player.isBlocked || player.velocity.x == 0) {
      refSprite.current.frame = frameConfig.idle;
      if (state != 'idle') setState('idle');
      return;
    }

    // RUNNING
    f.current += delta * 10 * speed * player.velocity.x;
    f.current %= 10;
    refSprite.current.frame = f.current;
    if (state != 'run') setState('run');
  });

  // SFX
  // const state = useSyncExternalStore(
  //   PlayerState.subscribe,
  //   PlayerState.getSnapshot
  // );
  useEffect(() => {
    let run = AssetService.getAsset('s_jeremy_run');
    run.loop = true;
    if (!run) return;

    switch (state) {
      case 'jump':
        const idx = randomIntRange(0, 4);
        let jump = AssetService.getAsset(`s_jeremy_jump${idx}`);
        jump.play();
        run.stop();
        break;
      case 'run':
        run.play();
        break;
      default:
        run.stop();
        break;
    }
  }, [state]);

  // const ready = useAppStore((state) => state.ready);
  // useEffect(() => {
  //   if (ready && getUrlBoolean('skipVerifyAge')) {
  //     console.log('Player', ready, 'remove stop');
  //     for (const player of players) {
  //       ECS.world.removeComponent(player, 'stop');
  //     }
  //   }
  // }, [ready]);

  return (
    <ECS.Entity ref={refEntity}>
      <ECS.Component
        name="isPlayer"
        data={true}
      />

      {/* <ECS.Component
        name="isBlocked"
        data={false}
      />
      <ECS.Component
        name="isJumping"
        data={false}
      /> */}

      <ECS.Component
        name="position"
        data={{ x: 0, y: 0, z: 0 }}
      />
      <ECS.Component
        name="velocity"
        data={{ x: 0, y: 0, z: 0 }}
      />
      <ECS.Component
        name="size"
        data={size}
      />
      <ECS.Component
        name="isCollider"
        data={true}
      />
      <ECS.Component
        name="stop"
        // data={!getUrlBoolean('skipVerifyAge')}
        data={true}
      />

      <ECS.Component name="three">
        <group name="player">
          <group position={[0, 0, 0.01]}>
            {debug && (
              <group>
                <mesh position={[0, size[1] * 0.5, 0.01]}>
                  <planeGeometry args={[size[0], size[1]]} />
                  <meshBasicMaterial
                    color="grey"
                    transparent
                    opacity={0.5}
                  />
                </mesh>
                <mesh position={[0, 0, 0.01]}>
                  <sphereGeometry args={[0.05]} />
                  <meshBasicMaterial
                    color="red"
                    transparent
                    opacity={0.5}
                  />
                </mesh>
              </group>
            )}

            <mesh
              scale={[1.05, -1.05, 1.05]}
              position={[0, size[1] * 0.5, 0]}
            >
              <planeGeometry args={[size[1], size[1]]} />
              <GBufferMaterial transparent>
                <MaterialModuleSpriteAnimated
                  ref={refSprite}
                  map={t_jeremy}
                  rows={4}
                  cols={4}
                  frames={16}
                  frame={0}
                />
                <MaterialModuleAlphaTest />
              </GBufferMaterial>
            </mesh>
          </group>
        </group>
      </ECS.Component>
    </ECS.Entity>
  );
};
